<template>
  <v-scale-transition>
    <v-card v-if="!lightMode" width="80%" class="time-on-call-card primary elevation-5">
      <v-card-title>
        <v-icon medium color="white">mdi-clock</v-icon>&nbsp;
        <span class="headline call-time white--text">{{ calltime | formatTime }}</span>
        <v-spacer/>
      </v-card-title>
      <div v-for="(call,idx) in calls.filter((c) => c.isConfirmed)" :key="idx"
        class="text-xs-left call-details blue-grey--text text--lighten-4 text-no-wrap text-truncate">
        <v-icon color="white" small>{{ callIcon(call) }}</v-icon>
        <v-icon color="white" small>
          mdi-radio-button-{{ idx === 0 ? 'checked' : 'unchecked' }}
        </v-icon>
        <v-tooltip bottom v-if="call.bargeinShow">
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" color="green lighten-3">
              mdi-headset
            </v-icon>
          </template>
          <span>
            {{bargeTooltip(call)}}
          </span>
        </v-tooltip>
        {{ call | callName }}
      </div>
    </v-card>
    <v-card v-if="lightMode && calls[0]" class="primary" :style="lightStyle">
      <v-icon color="white" :style="`font-size: ${this.nameFontSize}px`">{{ callIcon(calls[0]) }}</v-icon>
      <span class="white--text ml-1">{{ calltime | formatTime }}</span>
    </v-card>
  </v-scale-transition>
</template>

<script>
export default {
  name: 'calltime',
  props: {
    calls: {
      type: Array,
      required: true
    },
    lightMode: {
      type: Boolean,
      required: false,
      default: false
    },
    cardSize: {
      type: Number,
      required: false,
      default: 0
    },
    nameFontSize: {
      type: Number,
      required: false,
      default: 0
    },
    marginSize: {
      type: Number,
      required: false,
      default: 0
    }
  },
  data () {
    return {
      calltime: 0
    }
  },
  timer: 'setCalltime',
  mounted () { this.setCalltime() },
  computed: {
    // dynamic size based on the size slider in light mode
    lightStyle () {
      return `width: ${this.cardSize}px;position: absolute;font-size: ${this.nameFontSize}px;z-index:10;margin-top: ${this.marginSize}px`
    }
  },
  methods: {
    setCalltime: function () {
      const call = this.calls[0]
      this.calltime = Math.ceil((Date.now() - call.startTime) / 1000)
    },
    dirLabel: function (call) {
      return call.isIncoming
        ? this.$t('buddy.calltime.from')
        : this.$t('buddy.calltime.to')
    },
    bargeTooltip: function (call) {
      const bin = call.bargein
      if (!bin) return
      const mode = bin.mode === 'fullbarge' ? 'barge in' : 'whisper'
      const name = bin.spyerName ? `"${bin.spyerName}"` : ''
      return `<${bin.spyerNum}> ${name} (${mode})`
    },
    callIcon: function (call) {
      if (call.isParked) {
        return 'mdi-car-brake-parking'
      }

      if (call.isIncoming) {
        return 'mdi-call-received'
      }
      return 'mdi-call-made'
    }
  },
  filters: {
    callName: function (call) {
      if (!call) {
        this.dbg('warn: trying to change call name for an empty call object')
        return
      }
      let name = call.name?.replace(/^\s*"\s*(.*)\s*"\s*$/g, '$1') || ''
      if (name.length >= 22) {
        name = name.slice(0, 19) + '...'
      }
      return call.name === call.user
        ? call.user
        : `${call.user} ${name}`
    }
  }
}
</script>

<style scoped>
.time-on-call-card {
  position: absolute;
  right: 0;
  top: 36px;
  opacity: 0.76;
  border-color: transparent!important;
  cursor: default;
}
.call-details { padding: 0 10px 5px 10px; line-height: 20px }
.v-card__title { padding-bottom: 4px }
</style>
